import BulkTypeAssignDialog from './BulkTypeAssignDialog'

export default BulkTypeAssignDialog
